import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {useMutation} from '@github-ui/react-query'

import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import type {FeedbackType} from '../components/groups-feedback/GroupsFeedback'

type Input = {
  type: FeedbackType
  feedbackChoice?: string[]
  textResponse?: string
}

type RequestBody = {
  feedback: FeedbackType
  text_response?: string
  feedback_choice?: string[]
}

export function useSubmitGroupsFeedbackMutation() {
  const apiURL = usePageDataUrl(PageData.submitCopilotGroupsFeedback)
  return useMutation<Response, Error, Input>({
    mutationFn: async ({type, feedbackChoice, textResponse}) => {
      const body: RequestBody = {feedback: type}

      if (textResponse) {
        body.text_response = textResponse
      }

      if (feedbackChoice && feedbackChoice.length > 0) {
        body.feedback_choice = feedbackChoice
      }

      const response = await fetchWithErrorHandling(apiURL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body,
      })
      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
  })
}
